import React, { createContext, useContext, useEffect } from 'react';
import { useSessionTimer } from '../hooks/useSessionTimer';

const SessionContext = createContext();

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within SessionProvider');
  }
  return context;
};

export const SessionProvider = ({ children }) => {
  const { clearSession, resetTimer } = useSessionTimer();
  
  return (
    <SessionContext.Provider value={{ clearSession, resetTimer }}>
      {children}
    </SessionContext.Provider>
  );
};